export default __webpack_public_path__ + "static/twitter-76d774f1e462ee5c1066697abdd5d504.png";